jQuery(($) => {

    function activateField(el) {
        const $field = $(el).closest('.m-field');

        $field.addClass('m-field--active');
    }

    function focusField(el) {
        const $field = $(el).closest('.m-field');

        $field.addClass('m-field--focused');
    }

    function deactivateField(el) {
        const $field = $(el).closest('.m-field');
        const $valEl = $field.find('input, select, textarea');

        $field.removeClass('m-field--focused');

        if (!$valEl.val()) {
            $field.removeClass('m-field--active');
        }
    }

    if ($('.m-field .a-input')[0] || $('.m-field .a-select')[0] || $('.m-field .a-textarea')) {
        $('.m-field .a-input, .m-field .a-textarea').on('focus click', function () {
            focusField(this);
            activateField(this);
        });

        $('.m-field .a-input, .m-field .a-textarea, .m-field .a-select__input').blur(function () {
            deactivateField(this);
        });

        $('.m-field__select').on('openSelectList', function () {
            focusField(this);
        });

        $('.m-field__select').on('chooseSelectOption', function () {
            activateField(this);
        });

        $('.m-field__select').on('clearSelect', function () {
            deactivateField(this);
        });

        $('.m-field__select select').each(function () {
            if ($(this).prop('selected', true).length && $(this).val() !== '') {
                activateField(this);
            }
        });
    }


});